import { render, staticRenderFns } from "./iPhoneSearchSettings.vue?vue&type=template&id=3633798f&scoped=true&"
import script from "./iPhoneSearchSettings.vue?vue&type=script&lang=js&"
export * from "./iPhoneSearchSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3633798f",
  null
  
)

export default component.exports